module.exports = __webpack_public_path__ + "./assets/c5858fe5db09421f93365e9bf43f81dd.woff";